import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { SectionHeading } from "./SectionHeading";
import { Reveal } from "./Reveal";
import { FAQ_ITEMS } from "@/data/faq";

export const FaqSection = () => (
  <section id="faq" className="bg-[#080808] py-24 sm:py-32">
    <div className="mx-auto max-w-3xl px-6 lg:px-8">
      <SectionHeading
        eyebrow="Domande frequenti"
        title="Tutto quello che vuoi sapere."
        testid="faq-heading"
      />
      <Reveal>
        <Accordion
          type="single"
          collapsible
          className="w-full"
          data-testid="faq-accordion"
        >
          {FAQ_ITEMS.map((item, i) => (
            <AccordionItem
              key={item.q}
              value={`faq-${i}`}
              className="border-b border-[#1B1B1B]"
            >
              <AccordionTrigger
                data-testid={`faq-trigger-${i + 1}`}
                className="py-5 text-left text-sm font-semibold text-white hover:text-[#C9A45C] hover:no-underline sm:text-base [&[data-state=open]]:text-[#C9A45C]"
              >
                {item.q}
              </AccordionTrigger>
              <AccordionContent
                data-testid={`faq-content-${i + 1}`}
                className="text-sm leading-relaxed text-[#B8B8B8]"
              >
                {item.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </Reveal>
    </div>
  </section>
);
